import { useToastProvider } from '@qualio/ui-components';
import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import collaboratorsApi from '../api/collaborators.api';
import { UpdateCollaboratorsPayload } from '../types';
import { extractMessageFromError } from '../utils/errorUtils';
import { EventNotUpdated, EventUpdated } from '../displayStrings';

export const useUpdateCollaborators = (companyId: number, eventId: number) => {
  const { showToast } = useToastProvider();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const {
    mutateAsync: updateCollaborators,
    isLoading,
    isSuccess,
  } = useMutation(
    ({ collaborators, comment }: UpdateCollaboratorsPayload): Promise<void> =>
      collaboratorsApi.updateCollaborators(companyId, eventId, collaborators, comment),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['eventDetails', companyId, eventId]);
        showToast({
          title: EventUpdated,
          description: t('events.modals.collaboratorsSuccessfullyUpdated'),
          status: 'success',
          'data-cy': 'qe-update-collaborators-success-toast',
        });
      },
      onError: (error: AxiosError) => {
        showToast({
          title: EventNotUpdated,
          description: extractMessageFromError(error),
          status: 'error',
        });
      },
    },
  );

  return { updateCollaborators, isLoading, isSuccess };
};
